import { render, staticRenderFns } from "./SplitTest.vue?vue&type=template&id=33dbe844"
import script from "./SplitTest.vue?vue&type=script&setup=true&lang=ts"
export * from "./SplitTest.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports